import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { Action, Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";
import useSearch from "redux/hooks/useSearch";

import ArticleCard from "components/botanic/ArticleCard";
const ITEMS_PER_LOAD = 6;

const ArticleResults: React.FC = () => {
  const {
    query: { q, searchCategory },
  } = useRouter();
  const { article: articles, loadMoreSearchResults } = useSearch();

  const viewingCountOnLoad = searchCategory === "article" ? 12 : 3;
  const [viewingCount, setViewingCount] = useState(viewingCountOnLoad);
  const { publishEvent } = useEventTracker();

  useEffect(() => {
    setViewingCount(viewingCountOnLoad);
  }, [searchCategory]);

  const handleLoadMore = async () => {
    document.activeElement instanceof HTMLElement &&
      document.activeElement.blur();
    const newViewingCount = ITEMS_PER_LOAD + viewingCount;
    loadMoreSearchResults("article", newViewingCount);
    publishEvent({
      action: Action.click,
      category: Category.showMoreNewsResults,
      label: "",
    });
    setViewingCount(newViewingCount);
  };

  if (!articles || !articles.length) {
    return null;
  }

  const mappedArticles = articles
    .slice(0, viewingCount)
    .map(({ id, author, image, relativeLink, tags, title, date }) => ({
      author,
      date,
      href: relativeLink,
      id,
      imageUrl: image,
      tags,
      title,
    }));

  return (
    <>
      <h2 className="heading--l">News & culture</h2>
      <div className="font-normal mb-lg">matching "{q ? String(q) : ""}"</div>
      <div className="row">
        {mappedArticles.map((article) => (
          <div className="col md:col-1/2 lg:col-1/3 mb-md" key={article.id}>
            <ArticleCard
              author={article.author}
              date={article.date}
              href={article.href}
              imageUrl={article.imageUrl}
              onClick={() =>
                publishEvent({
                  action: Action.click,
                  articleId: article.id,
                  category: Category.newsArticleCard,
                  label: article.title,
                })
              }
              tags={article.tags}
              title={article.title}
            />
          </div>
        ))}
      </div>
      {articles.length >= viewingCount && (
        <button
          className="button mt-lg lg:mt-xl"
          onClick={handleLoadMore}
          data-testid="article-results-load-more"
        >
          show more news results
        </button>
      )}
    </>
  );
};

export default ArticleResults;
